import { Flex, Text } from '@mantine/core';

type VacancyPointProps = {
  title: string;
  value: string;
};

export const VacancyPoint = ({ title, value }: VacancyPointProps) => {
  return (
    <Flex direction='column' gap={8}>
      <Text c='tertiary.7' size='sm'>
        {title}
      </Text>
      <Text c='primary.7'>{value}</Text>
    </Flex>
  );
};
